import React, { useEffect, useState } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import update from 'immutability-helper';
import { useTranslation } from 'react-i18next';

import { Box, Button } from '@material-ui/core';
import { Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';

import ImageTable from '../visualization/ImageTable';

const ImageSelectionDialog = ({ open, close, publish, hint, }) => {
  const availableDates = useSelector((state) => state.acquisition.availableDates, shallowEqual);
  const metadata = useSelector((state) => state.acquisition.metadata, shallowEqual);
  const [t] = useTranslation();
  const [selected, setSelected] = useState(() => {
    const initial = {};
    availableDates?.forEach((image) => {
      initial[`${image.date}-${image.name}`] = false;
    });
    return initial;
  });

  const onSelectAll = (keys, checked) => {
    setSelected((prev) => {
      const changes = keys.reduce((acc, key) => {
        acc[key] = { $set: checked };
        return acc;
      }, {});
      return update(prev, changes);
    });
  };

  const handleChange = (index, checked) => {
    setSelected((prev) => update(prev, { [index]: { $set: checked } }));
  };

  const handleFinish = () => {
    const filtered = availableDates.filter((image, i) => {
      const key = `${image.date}-${image.name}`;
      return selected[key] === true;
    });
    publish(filtered);
  };

  window.sessionStorage.removeItem('coordinatesArray');

  return (
    <Dialog open={open} maxWidth="md" onClose={() => close()}>
      <DialogTitle>{t('forms.imageChooser.actions.analyzeShoreline.imageSelection.title')}</DialogTitle>
      <DialogContent>
        {hint}

        <ImageTable
          metadata={metadata}
          images={availableDates}
          selected={selected}
          onCheckboxChange={(i, checked) => handleChange(i, checked)}
          onSelectAll={onSelectAll}
          variant="modern"
        />
      </DialogContent>
      <DialogActions>
        <Button color="primary" onClick={() => close()}>
          {t('forms.imageChooser.actions.analyzeShoreline.imageSelection.cancel')}
        </Button>
        <Button color="primary" onClick={() => handleFinish()}>
          {t('forms.imageChooser.actions.analyzeShoreline.imageSelection.confirm')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ImageSelectionDialog;
